import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=7dbe812c&scoped=true&"
import script from "./UserData.vue?vue&type=script&lang=ts&"
export * from "./UserData.vue?vue&type=script&lang=ts&"
import style0 from "./UserData.vue?vue&type=style&index=0&id=7dbe812c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbe812c",
  null
  
)

export default component.exports